export const getType = (value) => typeof value;
export const isString = (value) => getType(value) === "string";
export const isNumber = (value) =>
  getType(value) === "number" && !isNaN(value) && isFinite(value);
export const isBoolean = (value) => getType(value) === "boolean";
export const isArray = (value) => Array.isArray(value);
export const isNotEmptyArray = (value) =>
  Boolean(isArray(value) && value.length);
